// extracted by mini-css-extract-plugin
export default {"iconContainer":"Icon_iconContainer__SGww8","box":"Icon_box__jOhct","iconSvg":"Icon_iconSvg__mH3ur","pointer":"Icon_pointer__uohAW"};